import React from 'react';
import listAmIcon from '../../imgs/list-am.png';
import listAmGrey from '../../imgs/list-am-grey.png';

interface Props {
    size?: number;
    className?: string;
    /** Серая монохромная эмблема (для тёмного футера) */
    grey?: boolean;
}

// Логотип list.am: цветной «клевер» или серая эмблема (grey).
const ListAmLogo: React.FC<Props> = ({ size = 18, className, grey }) => (
    <img
        src={grey ? listAmGrey : listAmIcon}
        alt="list.am"
        className={className}
        width={size}
        height={size}
        style={{ verticalAlign: 'middle', flexShrink: 0, borderRadius: 4 }}
    />
);

export default ListAmLogo;
